import type { CancelToken } from 'axios'
import { AxiosAction } from 'redux-axios-middleware'

import { OptionItems } from 'models/Modifier'
import { PaginationT } from 'models/Pagination'
import { ResolvedAxiosAction } from 'utilities/types'

export const GET_MODIFIERS = 'modifier/GET_MODIFIERS'
export const GET_MODIFIERS_SUCCESS = 'modifier/GET_MODIFIERS_SUCCESS'
export const GET_MODIFIERS_FAIL = 'modifier/GET_MODIFIERS_FAIL'
export const RESET_MODIFIER_IDS = 'modifier/RESET_MODIFIER_IDS'

export type GetModifiersParams = {
  search_term?: string
  page?: number
  item_ids?: string[]
  option_ids?: string[]
}

export type GetModifiersResponse = {
  option_items: OptionItems[]
  pagination: {
    total_pages: number
    per_page: number
    current_page: number
    total_count: number
  }
}

export function getModifiers(
  itemIds: string[] | undefined = undefined,
  optionIds: string[] | undefined = undefined,
  searchTerm: string = '',
  page: number = 1,
  cancelToken?: CancelToken
): AxiosAction<typeof GET_MODIFIERS, GetModifiersResponse> {
  const params: GetModifiersParams = {
    search_term: searchTerm,
    page: page,
  }
  const hasMultipleItemIds = itemIds && itemIds.length > 0
  const hasMultipleOptionIds = optionIds && optionIds.length > 0

  return {
    type: GET_MODIFIERS,
    payload: {
      client: 'default',
      request: {
        url: 'options',
        method: 'get',
        params: {
          ...params,
          ...(hasMultipleItemIds && { item_ids: itemIds }),
          ...(hasMultipleOptionIds && { option_ids: optionIds }),
        },
        ...(cancelToken && { cancelToken }),
      },
    },
  }
}

export function resetModifierIds() {
  return {
    type: RESET_MODIFIER_IDS,
  }
}

export type ResolvedAction =
  | ResolvedAxiosAction<ReturnType<typeof getModifiers>>
  | ResolvedAxiosAction<typeof resetModifierIds>

export type GetModifiersAction = AxiosAction<
  typeof GET_MODIFIERS,
  {
    option_items: OptionItems[]
    pagination: PaginationT
  }
>
